<template>
    <div>
        <div class="container alertForm w-100" v-if="alertForm">
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="row d-flex justify-content-end">
                    <div class="col-md-8 col-lg-6 col-xl-4">
                        <div class="card chat1">
                            <div class="card-header d-flex justify-content-between align-items-center p-3 bg-dark text-white border-bottom-0 " id="chat2">
                                <p class="mb-0 fw-bold">Alerte</p>
                                <i class="fas fa-times" @click="alertForm=false"></i>
                            </div>
                                <div class="container-fluid w-100">
                                <div class="d-flex flex-row justify-content-start w-100">
                                <div class="pt-3 pb-1 w-100">
                                    <label for="">Niveau d'urgence</label>
                                </div>
                                </div>
                                <div class="d-flex flex-row justify-content-start mb-2 w-100">
                                    <div class="pt-1 w-100">
                                        <b-form-group
                                            id="miveau-urgence"
                                            v-model="alerte.niveau_urgence_id"
                                            invalid-feedback="Niveau d'urgence est obligatoire"
                                            :state="niveaUrgenceState"
                                            required
                                            >
                                            <multiselect v-model="alerte.niveau_urgence_id" @select="showAlert" :options="pUrgencesAlarm" :multiple="false" placeholder="niveau d'urgence" selectLabel="Sélectionner" label="nom" track-by="id">
                                              <!-- affichage du multiselect plié -->
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <span>{{ option.id }}</span>
                                                    <!-- <span>&nbsp;{{ truncate( option.description , 18) }}</span> -->
                                                </template>
                                                <!-- affichage des options(multiselect déplié) -->
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="option__desc">
                                                    <span class="option__title">
                                                        <strong>{{option.id}}&nbsp;</strong>
                                                    </span> -
                                                    <span class="option__small">{{truncate( option.description, 22) }}</span>
                                                    </div>
                                                </template>
                                            </multiselect>
                                       </b-form-group>   
                                       <b-alert class="text-dark small-fw mt--3" dismissible fade @dismissed="describe=false"
                                            :show="describe" variant="secondary">{{alerte.niveau_urgence_id.description}} 
                                            <a class="close float-right text-light cursor" @click="describe=false">&times;</a>
                                        </b-alert>
                                    </div>
                                </div>
                                <div v-if="!hasPatientRole">
                                    <div class="d-flex flex-row justify-content-start w-100">
                                        <div class="pt-1 pb-1 w-100">
                                            <label for="">Patient</label>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row justify-content-start mb-2 w-100">
                                        <div class="py-1 w-100">
                                            <b-form-group
                                                id="patient_id"
                                                v-model="alerte.patient_id"
                                                :state="patientState"
                                                required
                                                label-for="patient-input"
                                                invalid-feedback="Patient est obligatoire">  
                                                <multiselect v-model="alerte.patient_id" :state="patientState" required invalid-feedback="Patient is required" :options="mPatients" :multiple="false" placeholder="Patient" selectLabel="Sélectionner" label="nom" track-by="id" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getSearchPatient"></multiselect>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-row justify-content-start w-100">
                                </div>
                                <div class="form-outline pb-1">
                                    <b-form-group
                                        label="Plaintes"
                                        label-for="plainte-input"
                                        invalid-feedback="Plainte est obligatoire"
                                        :state="plainteState"
                                        >  
                                        <div class="row">
                        <b-form-textarea
                        :class="isRecording? 'col-12 text-dark':'col-10 text-dark'"
                            id="name-input"
                            counter :rules="rules" 
                            v-model="text"
                            :state="plainteState"
                            placeholder="Entrez votre plainte"
                            required
                        ></b-form-textarea>
                        <div id="browser" v-if="this.browserName != 'Mozilla Firefox'" class='col-2 mt-3'>
                        <v-btn d-flex dark @click.stop="toggle ? endSpeechRecognition() : startSpeechRecognition()" icon :color="!toggle ? 'primary' : speaking ? 'red lighten-2' : 'red darken-4'" :class="{ pulse: toggle }">
                                 <div v-if="mediaRecorder">
                                            <slot :isRecording="isRecording"
                                                :startRecording="startRecording"
                                                :stopRecording="stopRecording"
                                                :deleteRecording="deleteRecording">
                                                <i v-if="!isRecording" @click="startRecording" class="cursor fa fa-microphone fa-2x text-green" aria-hidden="true"></i>
                                            </slot>
                                        </div>
                                           <!-- <vue-dictaphone @stop="handleRecording($event)" mime-type="audio/mp3" 
                                        </vue-dictaphone> -->

                        </v-btn></div>
                    </div>
                        <!-- <b-btn class="mt-3 text-red" v-if='hasText' @click='cleanReset' small dense>Reset</b-btn> -->
                            <div class="row w-100">
                            <div><vue-dictaphone-spectrum-analyser :style="{ opacity: isRecording ? .5 : .5, display:'block', width: '400px' }" class="my-1 w-100" v-if="isRecording"/></div> </div> 
                            <div class="py-1" v-if="isRecording"><p class="text-danger">La durée maximale est de 3 minutes</p></div>
                            <div v-if="audioSource" class="audio-sound d-flex justify-content-start mt-2">
                                <audio :src="audioSource" controls class=""></audio>
                                <li class="alert-icon del list-none ml-2 mt-3"><i @click="deleteRecording" class="pointer fas fa-trash text-red"></i></li>
                            </div>
                        </b-form-group>
                        <div class="d-flex justify-content-center">
                            <div class="p-2">
                                <h1 class="text-center" v-if="countAudio>0">{{ convertMsToMin }}</h1>
                            </div>
                            <div class="p-2">
                                <i v-if="isRecording" @click="stopRecording" class="pointer fa fa-microphone-slash fa-2x px-1 text-red" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>                                <div class="pt-3 pb-3 w-100">
                                    <b-button type="submit" variant="primary" class="btn btn-primary w-100">Envoyer</b-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="myAlert" v-if="hasPatientRole || hasSouscripteurRole">
            <i class="fixAlerte" v-if="!alertForm"  @click="OpenForm"> <img src="/img/add.png" class="img-fluid image" alt="create alert" width="30"></i>  
            <i class="fa fa-times fixAlerte"  @click="alertForm=false" v-if="alertForm"></i>  
            <div class="alertMessage">Cliquez pour ajouter une alerte.</div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import {mapGetters} from "vuex";
import Vue from 'vue';
import Dictaphone from '@/components/Dictaphone';
import Multiselect from 'vue-multiselect'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import AppConfig from "../constants/AppConfig";
const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = SpeechRecognition ? new SpeechRecognition() : false;

 const deviceInfos = navigator.mediaDevices.enumerateDevices();
export default {
    name: 'AlertLayout',
    props: {
        mimeType: {
        type: String,
        default: 'audio/mp3',
        },
    },
    components: {
        Autocomplete,
        Multiselect,
        Dictaphone
    },

    computed: {
        ...mapGetters(["errors", 'hasPatientRole', 'hasAdminRole', 'hasSouscripteurRole', 'hasGestionnaireRole','alertes','urgences']),

        mPatients: function() {
            let pArray = [];

            _.forEach(this.liste_patient.data, function(patient) {
                if (typeof patient == 'object'){
                    if(patient.user != null){
                        // console.log(patient.user);
                        let nom = patient.user.name ;
                        pArray.push({nom: nom, id: patient.user_id });

                        }
                    }
                }
            );
            return pArray;
        },
        
        convertMsToMin(){
            const m = Math.floor(this.countAudio % 3600 / 60).toString().padStart(2,'0'),
            s = Math.floor(this.countAudio % 60).toString().padStart(2,'0');
            return  m + ':' + s;
        },
        pUrgencesAlarm: function(){
            let mArray = [];
            _.forEach(this.urgences, function(urgence) {
                // console.log(urgence.id);
                // urgence =  urgence.description;
                let text =  urgence.id;
                let value =  urgence.valeur;
                let descriptions =  urgence.description;
                mArray.push({id: text, nom: value, description: descriptions});
            });
            //console.log(this.urgences);
            return mArray;
        },

        pUrgences: function(){
            let mArray = [];
            _.forEach(this.urgences, function(urgence) {
                // console.log(urgence.id);
                // urgence =  urgence.description;
                let text =  urgence.id;
                let value =  urgence.valeur;
                mArray.push({text: text, value: value });
            });
            return mArray;
        },
    },
    
    data() {
        return { 
            browserName: null,
            audioBlob: null,
            mediaRecorder: null,
            isRecording: false,
            audioSource: null,
            recordMode: {
                audio: 'press',
                video: 'press'
            },
            recordings: [],
            lang: "fr",
            error: false,
            speaking: false,
            toggle: false,
            runtimeTranscription: "",
            sentences: [],
            text: "",
            rules: [(v) => v.length <= 5000 || "Max 5,000 characters"],
            describe: false,
            liste_patient: [],
            loading: false,
            alerte: {
                patient_id:'',
                niveau_urgence_id:'',
                plainte:'',
            },
            patientState: null,
            niveaUrgenceState: null,
            plainteState: null,
            submittedNames: [],
            alertForm: false,
            settings: false,
            singleAlert:{},
            Home: false,
            mobileView: true,
            dismissSecs: 10,
            dismissCountDown: 0,
            uuid: this.$route.query.uuid,
            search: "",
            countAudio: 0
        }
    },

    methods: {
        stopRecording() {
            this.isRecording = false;
            this.mediaRecorder.stop();
            clearInterval(this.countInterval);
            this.endSpeechRecognition();
        },
        chromeAudio() {
            this.countInterval = setInterval(() => {
                this.countAudio += 1;
                /** 5 minutes */
                if (this.countAudio == 300) {
                this.stopRecording() ;
                }
            }, 1000);
        },
        startRecording() {
            this.countAudio=0;
            this.audioSource=null;
            this.chromeAudio();
            this.isRecording = true;
            this.mediaRecorder.start();
        },
        pauseRecording() {
            this.isRecording = false;
            this.mediaRecorder.pause();
        },
        deleteRecording() {
            this.error = false;
            this.speaking = false;
            this.toggle = false;
            this.runtimeTranscription = "";
            this.sentences = [];
            this.text = "";
            this.audioSource = null;
            this.audioBlob = null;
            this.countAudio = 0;
        },
        handleRecording({ blob, src }) {
            this.recordingFile = blob;
            this.audioSource = src;
        },
        onResult (data) {
            // console.log('The blob data:', data);
            // console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.recordings.push({
                src: window.URL.createObjectURL(data)
            })
        },
        cleanReset() {
            
        },
        speechEnd({ sentences, text }) {
            // console.log(recognition);
            this.sentences = sentences;
            this.text = text;
        },
        checkCompatibility() {
            if (!recognition) {
                this.error =
                "Speech Recognition is not available on this browser. Please use Chrome or Firefox";
            }
        },
        endSpeechRecognition() {
            recognition.stop();
            this.toggle = false;
            this.speaking = false;


            setTimeout(() => {
                this.speechEnd({
                    sentences: this.sentences,
                    text: `${this.sentences.join(". ")}`
                });
            }, 500);
        },
        startSpeechRecognition() {
            this.toggle = true;

            recognition.lang = this.lang;
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.maxAlternatives = 1;

            recognition.onspeechstart = () => {
                this.speaking = true;
            };

            recognition.onspeechend = () => {
                this.speaking = false;
            };

            recognition.onresult = (event) => {
                if (typeof event.results === "undefined") {
                recognition.stop();
                return;
                }
                if (this.text.length >= 1) {
                this.sentences = [];
                }

                for (var i = event.resultIndex; i < event.results.length; ++i) {
                if (event.results[i].isFinal) {
                    let finalSentence = event.results[i][0].transcript;

                    this.runtimeTranscription = event.results[i][0].transcript;

                    this.sentences.push(this.capitalizeFirstLetter(finalSentence));
                } else {
                    this.runtimeTranscription = event.results[i][0].transcript;
                }
                }
            };

            recognition.start();
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        truncate(str, n){
            return (str.length > n) ? str.slice(0, n-1) + '...' : str;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        }, 
        showAlert() {
            this.describe = true
        },
        changeColor(alerte) {
            if (alerte === 1) {
                return 'secondary';
            }
            else if (alerte === 2) {
                return 'success';
            }
            else if (alerte === 3) {
                return 'primary';
            }
            else if (alerte === 4) {
                return 'danger';
            }
		},
        getSearchPatient(patient){
            this.loading = true;
            fetch(AppConfig.apiUrl+`/v2/patients?search=${patient}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                .then(res => res.json())
            .then(res => {
                this.loading = false;
                this.liste_patient = res
            }).catch(error => {
                console.log('error ', error);
            })
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            // this.nameState = valid
            this.patientState = valid
            this.niveaUrgenceState = valid
            this.plainteState = valid
            
            return valid
        },
        resetModal() {
            this.plainte = ''
            this.patient_id = ''
            this.niveau_urgence_id = ''
            // this.nameState = null
            this.patientState = null
            this.niveaUrgenceState = null
            this.plainteState = null
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                // Swal.fire(
                //     'Oups !',
                //     "Une erreur a été rencontrée, veuillez réessayer s'il vous plaît !",
                //     'error'
                // )
                return
            }
                // Push the name to submitted names
                this.submittedNames.push(this.alerte)

                let args = {};

                let formData = new FormData(), file = null;
                if(!Array.isArray(this.recordingFile)){
                    let blob = new Blob([this.recordingFile], { type: "audio/mp3" });
                        file = new File([blob], 'audio.mp3');
                }


                if(this.hasPatientRole){
                    formData.append("niveau_urgence_id", this.alerte.niveau_urgence_id.id);
                    formData.append("plainte", this.text);
                    formData.append("patient_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }
                else{
                    formData.append("patient_id", this.alerte.patient_id.id); // this should be your image
                    formData.append("niveau_urgence_id", this.alerte.niveau_urgence_id.id);
                    formData.append("plainte", this.text);
                    formData.append("creator_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }

                if(!Array.isArray(this.recordingFile)){
                    formData.append('audio', file);
                }
                // this.loading = true;
                // console.log(args);

                let successMessage = this.$i18n.t('message.alerteCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                this.$store.dispatch('createMalerte', {args: formData, errorMessages, successMessage })
                .then(() => {
                    this.alertForm= false;
                    this.alerte.niveau_urgence_id.id='';
                    this.resetModal();
                    this.getAlertes();
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                });

                this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },
        getAlertes(page = 1, search = "", size = 25, statut_id = "") {
            let args = {
                page: page,
                search: search,
                size: size,
                statut_id: statut_id,
            };

            this.$store.dispatch('getAlertes', { args : args });
        },

        getNiveauUrgence() {
            let args = {
                offset: this.offset,
                limit: this.limit,
                // id:(JSON.parse(localStorage.getItem('user')))['id']
            };

            this.$store.dispatch('getNiveauUrgence', { args : args });
        },
        OpenForm(){
            this.alertForm= true, 
            this.getNiveauUrgence();
        },

        infoModal(cmd) {
          this.settings=true,  
            this.$bvModal.show('modalInfo');
            this.singleAlert=cmd
            
        },
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
    },
    watch: {
        audioBlob() {
        this.$emit('stop', {
            blob: this.audioBlob,
            src: URL.createObjectURL(this.audioBlob),
        });
        this.recordingFile=this.audioBlob,
        this.audioSource=URL.createObjectURL(this.audioBlob)
        },
        
    },
    created() {
            this.browserName = (function (agent) {        
                switch (true) {
                    case agent.indexOf("edge") > -1: return "MS Edge";
                    case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
                    case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
                    case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
                    case agent.indexOf("trident") > -1: return "MS IE";
                    case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
                    case agent.indexOf("safari") > -1: return "Safari";
                    default: return "other";
                }
            })(window.navigator.userAgent.toLowerCase());

        // document.getElementById("browser").innerText="You are using "+ browserName +" browser"; 
        // console.log(browserName !== 'Mozilla Firefox');
    },
    async mounted() {

        if(this.uuid != undefined){
            this.$bvModal.show("modal-"+this.uuid);
        }

        this.checkCompatibility();

        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (error) {
            this.$emit('error', '`navigator.mediaDevices.getUserMedia()` failed.');
            return Promise.resolve();
        }
        const recorder = new MediaRecorder(stream);
        let chunks = [];
        recorder.addEventListener('stop', () => {
            this.audioBlob = new Blob(chunks, { type: this.mimeType });
            chunks = [];
        });
            recorder.addEventListener('dataavailable', (e) => {
            chunks.push(e.data);
        });
        this.mediaRecorder = recorder;
    },
    beforeDestroy() {
        recognition.abort();
    }
    
}
</script>